<template>
    <div>
        <h1>Edit your List</h1>
        <ChecklistCreateForm :id="this.$route.params.id" :slug="this.$route.params.slug"/>
    </div>
</template>

<script>
import ChecklistCreateForm from '@/components/forms/checklist-create-form.vue'

export default {
  name: 'EditChecklist',
  components: {
    ChecklistCreateForm
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
}
</script>
